import zones from "@/lib/timezones.json";

export interface LocationGuess {
  latitude: number;
  longitude: number;
  label: string;
}

// Approximate location from the browser's time-zone name only; nothing leaves the device.
export function guessLocationFromTimeZone(): LocationGuess {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const hit = (zones as unknown as Record<string, [number, number, string]>)[tz];
  if (hit) return { latitude: hit[0], longitude: hit[1], label: hit[2] };
  const meridian = (-new Date().getTimezoneOffset() / 60) * 15;
  if (meridian === 0) return { latitude: 51.4779, longitude: 0, label: "Greenwich, United Kingdom" };
  return { latitude: 0, longitude: meridian, label: `${tz || "Your time zone"} meridian` };
}
